export default {
  title: 'Nuevo menú',
  headers: {
    edit_time: 'Editar horario',
  },
  labels: {
    select_all: 'Seleccionar todo',
  },
  fields: {
    name: {
      label: 'Nombre',
      placeholder: 'Introduce el nombre del menú',
    },
    sorting_order: {
      label: 'Orden de visualización del menú',
      placeholder: 'Introduce el orden de visualización del menú',
    },
    has_separate_schedule: {
      label: 'Difiere del horario habitual de apertura',
    },
    selected_days: {
      label: 'Días seleccionados',
    },
    opening_time: {
      label: 'Hora de apertura',
    },
    closing_time: {
      label: 'Hora de cierre',
    },
  },
  buttons: {
    add_opening_time: 'Añadir horario de apertura',
    add: 'Añadir',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
  },
  feedback: {
    missing_info: 'Información incompleta',
  },
  toasts: {
    menu_got_created: 'Menú creado',
    menu_got_updated: 'Menú actualizado',
  },
};
